import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 22C10.896 21.9946 10.0009 21.1039 9.99 20H13.99C13.9921 20.2674 13.9411 20.5325 13.84 20.78C13.5777 21.382 13.0418 21.8211 12.4 21.96C12.2686 21.9886 12.1344 22.002 12 22ZM20 19H4V17L6 16V10.5C5.94732 9.08912 6.26594 7.68913 6.924 6.44C7.57904 5.28151 8.6987 4.45888 10 4.18V2H14V4.18H14.006H14.011C14.036 4.18 14.06 4.19 14.084 4.196C16.611 4.845 18 7.082 18 10.5V16L20 17V19ZM9 11V13H15V11H9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "NotificationMinus"
);
